import React from 'react';
import { Link } from 'react-router-dom';

import { useData } from '@shared/api/hooks/useData';
import { Button } from '@shared/ui/components/Button';
import { DataTable } from '@shared/ui/components/DataTable';
import { Icon } from '@shared/ui/components/Icon';
import { Portlet } from '@shared/ui/components/Portlet';
import { deleteVenue } from '@shared/venues/endpoints/deleteVenue';
import { getVenues } from '@shared/venues/endpoints/getVenues';

import { AdminWrapper } from '@admin/layout/components/AdminWrapper';

type Venue = App.Domain.Event.Data.VenueData;

export function ListVenues() {
  const venues = useData<Venue>({
    key: 'venues',
    get: getVenues,
    defaults: { sort: 'name' },
  });

  return (
    <AdminWrapper
      title="Venues"
      actions={[
        <Button asChild>
          <Link to="/admin/new-venues/create">
            <Icon icon="plus" />
            Create
          </Link>
        </Button>,
      ]}
    >
      <Portlet>
        <DataTable<Venue>
          data={venues}
          columns={[
            {
              name: 'name',
              filterable: true,
            },
            {
              name: 'updatedAt',
              label: 'Last Updated',
              type: 'datetime',
            },
          ]}
          editUrl={(venue) => `/admin/new-venues/${venue.id}/edit`}
          onDelete={deleteVenue}
        />
      </Portlet>
    </AdminWrapper>
  );
}
